module.exports = __webpack_public_path__ + "static/media/SANCHIT-TODI.74238487.png";